import Navbar from "./Components/Navbar/Navbar";
import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <Navbar />
      <Outlet /> {/* This renders the matched child route */}
    </>
  );
};

export default Layout;
